<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>查询条件</span>
          </div>
          <el-form :inline="true" :model="housekeepingServPoolPayInfo.conditions" class="flex justify-start">
            <el-form-item>
              <el-input v-model="housekeepingServPoolPayInfo.conditions.servName" placeholder="请输入服务名称" clearable />
            </el-form-item>
            <el-form-item>
              <el-input v-model="housekeepingServPoolPayInfo.conditions.applyName" placeholder="请输入申请人" clearable />
            </el-form-item>
            <el-form-item>
              <el-input v-model="housekeepingServPoolPayInfo.conditions.applyTel" placeholder="请输入联系电话" clearable />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="_queryHousekeepingServPoolMethod">
                <i class="el-icon-search"></i> 查询
              </el-button>
              <el-button @click="_resetHousekeepingServPoolMethod">
                <i class="el-icon-refresh"></i> 重置
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <span>服务支付</span>
      </div>
      <el-table :data="housekeepingServPoolPayInfo.housekeepingServPools" border style="width: 100%">
        <el-table-column prop="servName" label="服务名称" align="center" />
        <el-table-column prop="cartId" label="订单编号" align="center">
          <template slot-scope="scope">
            {{ scope.row.cartId === '-1' ? '电话预约' : scope.row.cartId }}
          </template>
        </el-table-column>
        <el-table-column prop="applyName" label="申请人" align="center" />
        <el-table-column prop="applyTel" label="联系方式" align="center" />
        <el-table-column prop="appointmentTime" label="预约时间" align="center" />
        <el-table-column prop="createTime" label="申请时间" align="center" />
        <el-table-column prop="stateName" label="状态" align="center" />
        <el-table-column prop="context" label="备注" align="center" />
        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-button size="mini" @click="_toPay(scope.row)">
              缴费
            </el-button>
            <el-button size="mini" @click="_openDetail(scope.row)">
              详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next" :total="housekeepingServPoolPayInfo.total" class="pagination" />
    </el-card>
  </div>
</template>

<script>
import { queryHousekeepingServPool } from '@/api/housekeeping/housekeepingServPoolPayApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'HousekeepingServPoolPay',
  data() {
    return {
      housekeepingServPoolPayInfo: {
        housekeepingServPools: [],
        total: 0,
        records: 1,
        conditions: {
          servName: '',
          state: '1400',
          applyName: '',
          applyTel: '',
          shopId: ''
        }
      },
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this.housekeepingServPoolPayInfo.conditions.shopId = getShopId()
    this._listHousekeepingServPays(this.currentPage, this.pageSize)
  },
  methods: {
    async _listHousekeepingServPays(page, rows) {
      this.housekeepingServPoolPayInfo.conditions.page = page
      this.housekeepingServPoolPayInfo.conditions.row = rows

      const params = {
        ...this.housekeepingServPoolPayInfo.conditions,
        servName: this.housekeepingServPoolPayInfo.conditions.servName.trim(),
        applyName: this.housekeepingServPoolPayInfo.conditions.applyName.trim(),
        applyTel: this.housekeepingServPoolPayInfo.conditions.applyTel.trim()
      }

      try {
        const res = await queryHousekeepingServPool(params)
        this.housekeepingServPoolPayInfo.total = res.total
        this.housekeepingServPoolPayInfo.records = res.records
        this.housekeepingServPoolPayInfo.housekeepingServPools = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _queryHousekeepingServPoolMethod() {
      this.currentPage = 1
      this._listHousekeepingServPays(this.currentPage, this.pageSize)
    },
    _resetHousekeepingServPoolMethod() {
      this.housekeepingServPoolPayInfo.conditions.servName = ''
      this.housekeepingServPoolPayInfo.conditions.applyName = ''
      this.housekeepingServPoolPayInfo.conditions.applyTel = ''
      this.currentPage = 1
      this._listHousekeepingServPays(this.currentPage, this.pageSize)
    },
    _toPay(pool) {
      this.$router.push({
        path: '/pages/goods/housekeepingServPoolPayOrder',
        query: {
          poolId: pool.poolId,
          servName: pool.servName
        }
      })
    },
    _openDetail(pool) {
      this.$router.push({
        path: '/pages/housekeeping/housekeepingServDetail',
        query: {
          poolId: pool.poolId
        }
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listHousekeepingServPays(this.currentPage, this.pageSize)
    }
  }
}
</script>

<style scoped>
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>
